module.exports = __webpack_public_path__ + "static/media/image19.29cd2d0f.jpg";